// Filtri puri estratti da SpeseCollaboratoreView per essere testabili senza
// dover renderizzare l'intero componente.

/**
 * Incarichi da mostrare in "Le Mie Spese e KM" per il mese/anno selezionato:
 * solo quelli con almeno una relazione con `dataRelazione` nel periodo.
 * Input tipizzati larghi (any[]) per accettare sia DTO sia stato locale;
 * `spese` resta in firma per compatibilità ma non è più usato.
 */
export const filterIncarichiMese = <I extends { id: number | string }>(
    incarichi: I[],
    _spese: Array<{ incaricoId?: number | string | null }>,
    relazioni: Array<{ incaricoId?: number | string | null; dataRelazione?: string | null }>,
    mese: number,
    anno: number,
): I[] => {
    const inMese = (iso?: string | null) => {
        if (!iso) return false;
        const d = new Date(iso);
        return d.getMonth() + 1 === mese && d.getFullYear() === anno;
    };
    return incarichi.filter(inc =>
        relazioni.some(r => r.incaricoId === inc.id && inMese(r.dataRelazione))
    );
};
